<template>
    <div class="order-status-page page-details order-payment-page" v-if="userAuthenticated">
        <job-navigation :loading="loading" :fixedToTop="true" @closePage="closePage" :title="orderStatusData.title"
                        :sub-title="orderStatusData.customerOrderId"></job-navigation>

        <div class="wrapper" v-show="!loading">
            <div class="main-col">

                <h2 class="box-label">Számlázási adatok</h2>

                <div class="box shipping-data">
                    <template>
                        <div style="margin-left: 20px" class="input-wrapper place">
                            <div class="radio">
                                <input
                                    type="radio"
                                    name="billingSelf"
                                    id="bl1"
                                    :value="true"
                                    v-model="billingSelf"
                                    @change="setBillingType"
                                >
                                <label for="bl1">Saját névre kérem a számlát</label>
                            </div>
                            <div class="radio">
                                <input
                                    type="radio"
                                    name="billingSelf"
                                    id="bl2"
                                    :value="false"
                                    v-model="billingSelf"
                                    @change="setBillingType"
                                >
                                <label for="bl2">Más nevére kérem a számlát</label>
                            </div>
                        </div>

                        <div v-if="!billingSelf" style="margin-left: 20px" class="input-wrapper place"
                             :class="{'error' : validation['billing.isTaxNumber']}">
                            <span class="input-error">{{ validation['billing.isTaxNumber'] }}</span>
                            <div class="radio">
                                <input
                                    type="radio"
                                    name="isTaxNumber"
                                    id="tl1"
                                    :value="true"
                                    v-model="isTaxNumber"
                                >
                                <label for="tl1">Cég nevére</label>
                            </div>
                            <div class="radio">
                                <input
                                    type="radio"
                                    name="isTaxNumber"
                                    id="tl2"
                                    :value="false"
                                    v-model="isTaxNumber"
                                >
                                <label for="tl2">Nem cég nevére</label>
                            </div>
                        </div>

                        <div v-if="!billingSelf && isTaxNumber" class="input-wrapper"
                             :class="{'error' : validation['billing.taxNumber']}">
                            <label class="text-input-label" for="shipping-email-order-details">Cég adószám</label>
                            <input
                                type="text"
                                id="shipping-email-order-details"
                                v-mask="{mask: '99999999-9-99', greedy: true, autoUnmask: false}"
                                v-model="details.taxNumber"
                            >
                            <span class="input-error">{{ validation['billing.taxNumber'] }}</span>
                        </div>

                        <div class="input-wrapper" :class="{'error' : validation['billing.name']}">
                            <label class="text-input-label" for="shipping-name-order-details">
                                {{ $t('order.page.details.transport.field.shipping_name.label') }}
                            </label>
                            <input type="text" id="shipping-name-order-details" v-model="details.billingName"
                                   :disabled="billingSelf">
                            <span class="input-error">{{ validation['billing.name'] }}</span>
                        </div>

                        <div class="billing--row">
                            <div class="input-wrapper shipping-zip" :class="{'error' : validation['billing.zip']}">
                                <label class="text-input-label" for="shipping-zip-order-details">{{
                                        $t('order.page.details.transport.field.shipping_zip.label')
                                    }}</label>
                                <input
                                    ref="billingAddressZip"
                                    v-model="details.billingZip"
                                    :disabled="billingSelf"
                                    @input="inputBillingZip"
                                    @focus="checkBillingZip"
                                    @blur="emptyBillingCityList"
                                    type="number"
                                    min="1000"
                                    max="9999"
                                    id="shipping-zip-order-details"
                                    v-autocomplete-off
                                    v-disable-mouse-wheel
                                >
                                <span class="input-error">{{ validation['billing.zip'] }}</span>
                                <ul class="dropdown-list" v-show="billingCityList.length > 0">
                                    <li
                                        v-for="(city, index) in billingCityList"
                                        :key="index"
                                        @click="writeBillingCityName(city)">
                                        {{ city }}
                                    </li>
                                </ul>
                            </div>

                            <div class="input-wrapper shipping-city" :class="{'error' : validation['billing.city']}">
                                <label class="text-input-label" for="shipping-city-order-details">{{
                                        $t('order.page.details.transport.field.shipping_city.label')
                                    }}</label>
                                <input
                                    ref="billingAddressCity"
                                    v-model="details.billingCity"
                                    :disabled="billingSelf"
                                    @input="inputBillingCity"
                                    @focus="checkBillingCity"
                                    @blur="blurBillingCity"
                                    id="shipping-city-order-details"
                                    type="text"
                                    v-autocomplete-off
                                >
                                <span class="input-error">{{ validation['billing.city'] }}</span>
                                <ul class="dropdown-list" v-show="billingZipList.length > 0">
                                    <li
                                        v-for="(zip, index) in billingZipList"
                                        :key="index"
                                        @click="writeBillingZip(zip)">
                                        {{ zip }}
                                    </li>
                                </ul>
                            </div>

                            <div class="input-wrapper" :class="{'error' : validation['billing.address']}">
                                <label class="text-input-label" for="shipping-address-order-details">{{
                                        $t('order.page.details.transport.field.shipping_address.label')
                                    }}</label>
                                <input
                                    type="text"
                                    id="shipping-address-order-details"
                                    v-model="details.billingAddress"
                                    :disabled="billingSelf"
                                    v-autocomplete-off
                                >
                                <span class="input-error">{{ validation['billing.address'] }}</span>
                            </div>
                        </div>

                        <div class="input-wrapper" :class="{'error' : validation['billing.phone']}">
                            <label class="text-input-label" for="shipping-phone-order-details">{{
                                    $t('order.page.details.transport.field.shipping_phone.label')
                                }}</label>
                            <input
                                type="text"
                                id="shipping-phone-order-details"
                                v-model="details.billingPhone"
                                :disabled="billingSelf"
                                v-mask="{mask: '+36 99/999 9999', greedy: true, autoUnmask: true}"
                                :placeholder="this.$t('order.page.details.transport.field.shipping_phone.placeholder')"
                            >
                            <span class="input-error">{{ validation['billing.phone'] }}</span>
                        </div>

                        <div class="input-wrapper" :class="{'error' : validation['billing.email']}">
                            <label class="text-input-label" for="shipping-email-order-details">{{
                                    $t('order.page.details.transport.field.shipping_email.label')
                                }}</label>
                            <input
                                type="text"
                                id="shipping-email-order-details"
                                v-model="details.billingEmail"
                                :disabled="billingSelf"
                                :placeholder="this.$t('order.page.details.transport.field.shipping_email.placeholder')"
                            >
                            <span class="input-error">{{ validation['billing.email'] }}</span>
                        </div>
                    </template>
                </div>

                <h2 class="box-label">Szállítási adatok</h2>

                <div class="box shipping-data">
                    <div class="text-input-label">
                        Kérjük ellenőrizze a szállítási adatokat!
                    </div>
                    <template>
                        <div class="input-wrapper" :class="{'error' : validation.shippingName}">
                            <label class="text-input-label" for="shipping-name-order-details">{{
                                    'Név'
                                }}</label>
                            <input
                                type="text"
                                id="shipping-name-order-details"
                                v-model="details.shippingName"
                                :disabled="false"
                            >
                            <span class="input-error">{{ validation.shippingName }}</span>
                        </div>

                        <div class="billing--row">
                            <div class="input-wrapper shipping-zip" :class="{'error' : validation.shippingZip}">
                                <label class="text-input-label" for="shipping-zip-order-details">{{
                                        $t('order.page.details.transport.field.shipping_zip.label')
                                    }}</label>
                                <input
                                    ref="addressZip"
                                    v-model="details.shippingZip"
                                    :disabled="false"
                                    @input="inputZip"
                                    @focus="checkZip"
                                    @blur="emptyCityList"
                                    type="number"
                                    min="1000"
                                    max="9999"
                                    id="shipping-zip-order-details"
                                    v-autocomplete-off
                                    v-disable-mouse-wheel
                                >
                                <span class="input-error">{{ validation.shippingZip }}</span>
                                <ul class="dropdown-list" v-show="cityList.length > 0">
                                    <li
                                        v-for="(city, index) in cityList"
                                        :key="index"
                                        @click="writeCityName(city)">
                                        {{ city }}
                                    </li>
                                </ul>
                            </div>

                            <div class="input-wrapper shipping-city" :class="{'error' : validation.shippingCity}">
                                <label class="text-input-label" for="shipping-city-order-details">{{
                                        $t('order.page.details.transport.field.shipping_city.label')
                                    }}</label>
                                <input
                                    ref="addressCity"
                                    v-model="details.shippingCity"
                                    :disabled="false"
                                    @input="inputCity"
                                    @focus="checkCity"
                                    @blur="blurCity"
                                    id="shipping-city-order-details"
                                    type="text"
                                    v-autocomplete-off
                                >
                                <span class="input-error">{{ validation.shippingCity }}</span>
                                <ul class="dropdown-list" v-show="zipList.length > 0">
                                    <li
                                        v-for="(zip, index) in zipList"
                                        :key="index"
                                        @click="writeZip(zip)">
                                        {{ zip }}
                                    </li>
                                </ul>
                            </div>

                            <div class="input-wrapper" :class="{'error' : validation.shippingAddress}">
                                <label class="text-input-label" for="shipping-address-order-details">{{
                                        $t('order.page.details.transport.field.shipping_address.label')
                                    }}</label>
                                <input
                                    type="text"
                                    :disabled="false"
                                    id="shipping-address-order-details"
                                    v-model="details.shippingAddress"
                                    v-autocomplete-off
                                >
                                <span class="input-error">{{ validation.shippingAddress }}</span>
                            </div>
                        </div>
                    </template>
                </div>

                <!--                <h2 class="box-label">{{ orderStatusData.title }}: {{ orderStatusData.customerOrderId }}</h2>-->

                <table v-show="items && items.length" class="table products-data">
                    <thead>
                    <tr>
                        <th>{{ $t('order.page.status.products.column.name') }}</th>
                        <th>Egységár</th>
                        <th>{{ $t('order.page.status.products.column.amount') }}</th>
                        <th>Nettó ár összesen</th>
                    </tr>
                    </thead>
                    <template v-for="item in items">
                        <tr :key="item.id">
                            <td>{{ item.name }}</td>
                            <td>{{ item.price | formatPrice }} Ft</td>
                            <td>{{ item.amount }} {{ item.unit }}</td>
                            <td>{{ item.price * item.amount | formatPrice }} Ft</td>
                        </tr>
                    </template>
                </table>

                <div class="box submit">
                    <div class="row">

                        <div class="text-info-bold mb-4">
                            Összesen: {{ paymentTransaction?.total | formatPrice(true) }} Ft
                        </div>

                        <a href="https://simplepartner.hu/PaymentService/Fizetesi_tajekoztato.pdf" target="_blank">
                            <img class="mb-4" style="margin-top: 15px" alt="OTP Simple" src="@/assets/images/simplepay-payments.png">
                        </a>

                        <div v-if="gateways && gateways.length > 1" class="input-block input-block--full-width" style="padding-top: 1em">
                            <span class="text-input-label">Tesztelés</span>
                            <custom-select
                                :options="gateways"
                                :selectedItem="gateway"
                                @changed="(el) => {gateway = el}"
                            ></custom-select>
                        </div>

                        <div class="checkbox" style="padding-top: 1em">
                            <input type="checkbox" v-model="aszf" id="aszf">
                            <label for="aszf">
                                Elfogadom a
                                <a href="javascript:void(0)" @click="openModal('terms')">{{ $t('common.support.button.terms')}}</a>
                                -et
                            </label>
                        </div>

                        <div class="checkbox" style="padding-top: 1em">
                            <input type="checkbox" v-model="simple" id="simple">
                            <label for="simple">
                                Tudomásul veszem, hogy a BMI Magyarország Kft. (H-8200 Veszprém, Házgyári út 1.) adatkezelő által a(z)
                                epartnerbmi.hu felhasználói adatbázisában tárolt alábbi személyes
                                adataim átadásra kerülnek az OTP Mobil Kft., mint adatfeldolgozó részére. Az
                                adatkezelő által továbbított adatok köre az alábbi: Név, email cím, telefonszám, számlázási cím, szállítási cím.
                                Az adatfeldolgozó által végzett adatfeldolgozási tevékenység jellege és célja a
                                SimplePay Adatkezelési tájékoztatóban, az alábbi linken tekinthető meg:
                                <a href="http://simplepay.hu/vasarlo-aff" target="_blank">http://simplepay.hu/vasarlo-aff</a>
                            </label>
                        </div>
                    </div>

                    <div class="row row-buttons" style="padding-top: 0;">
                        <button
                            :disabled="!aszf || !simple"
                            class="btn btn-primary"
                            type="button"
                            @click="fulfillTransaction"
                        >
                            Fizetés
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="is-loading" v-show="loading"></div>

        <notification></notification>

        <modal-terms :open="openedModal === 'terms'" @close="closeModal()"></modal-terms>
    </div>
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'

// import { stickyColHandler } from '../plugins/helpers.js'
import {MdIcon} from 'vue-material/dist/components'
import VTooltip from 'v-tooltip'
import Scrollspy from 'vue2-scrollspy'

import JobNavigation from '../components/navigations/JobNavigation.vue'
import Notification from '../components/Notification.vue'
import CustomSelect from "@/components/dropdowns/CustomSelect.vue";
import {scrollToError} from "@/plugins/helpers";
import i18n from "@/i18n";
import ModalTerms from "@/components/modals/ModalTerms.vue";

Vue.use(MdIcon)
Vue.use(VTooltip)
Vue.use(Scrollspy)

export default {
    name: 'OrderPayment',

    data() {
        return {
            loading: true,
            openedModal: '',
            aszf: false,
            simple: false,
            billingSelf: true,
            isTaxNumber: null,
            details: {},
            openProductsTable: true,
            openHistory: false,
            orderStatusData: {
                permissions: {}
            },
            items: null,
            gateway: null,
            gateways: null,
            order: null,
            paymentTransaction: null,
            transactionUrl: null,
            cityList: [],
            billingCityList: [],
            zipList: [],
            billingZipList: [],
        }
    },

    mounted() {
        this.$store.dispatch('FETCH_CURRENT_USER').then(() => {
            window.scrollTo(0, 0);
            this.fetchOrderStatus()
            this.startPay()
        }).catch((redirect) => {
            redirect && this.$router.push({name: 'OrderList'})
        })
    },

    watch: {
        '$route'() {
            this.fetchOrderStatus()
        },

        'details.billingName': {
            handler: function () {
                this.removeValidation('billing.name')
            }
        },

        'details.billingPhone': {
            handler: function () {
                this.removeValidation('billing.phone')
            }
        },

        'details.billingEmail': {
            handler: function () {
                this.removeValidation('billing.email')
            }
        },

        'details.billingZip': {
            handler: function () {
                this.removeValidation('billing.zip')
            }
        },

        'details.billingCity': {
            handler: function () {
                this.removeValidation('billing.city')
            }
        },

        'details.billingAddress': {
            handler: function () {
                this.removeValidation('billing.address')
            }
        },

        'details.shippingName': {
            handler: function () {
                this.removeValidation('shippingName')
            }
        },

        'details.shippingZip': {
            handler: function () {
                this.removeValidation('shippingZip')
            }
        },

        'details.shippingCity': {
            handler: function () {
                this.removeValidation('shippingCity')
            }
        },

        'details.shippingAddress': {
            handler: function () {
                this.removeValidation('shippingAddress')
            }
        },

        orderDetails: {
            handler: function (val) {
                console.log('orderDetails', val)
                this.details = {
                    ...val,
                    billingName: '',
                    billingZip: '',
                    billingCity: '',
                    billingAddress: '',
                    billingEmail: '',
                    billingPhone: '',
                }

                if (this.details.customer === null) {
                    this.details.customer = {
                        id: null,
                        name: ''
                    }
                }

                this.setBillingType()
            }
        },

        validation: {
            handler: function () {
                if (this.disableScroll) {
                    this.disableScroll = false
                } else {
                    scrollToError()
                }
            }
        }
    },

    methods: {
        fetchOrderStatus() {
            let message = {
                id: this.$route.params.orderId,
                type: 'order'
            }

            this.loading = true

            this.$store.dispatch('FETCH_ORDER_DETAILS', message); // Setting order details

            this.$store.dispatch('FETCH_ORDER_STATUS', message).then(() => {
                this.orderStatusData = this.orderStatus
                this.openHistory = !this.orderStatusData.ordered
                this.loading = false
            }).catch(() => {
                this.$router.push({name: 'OrderStatus', params: {orderId: this.$route.params.orderId}})
            })
        },

        startPay() {
            this.loading = true

            this.$store.dispatch('ORDER_START_PAY', {id: this.$route.params.orderId}).then((resp) => {
                console.log(resp)
                this.gateways = resp.gateways

                if (this.gateways.length) {
                    this.gateway = this.gateways[0]
                }

                this.order = resp.order
                this.paymentTransaction = resp.paymentTransaction
                this.transactionUrl = resp.transactionUrl
                this.items = resp.items
                this.loading = false
            });
        },

        async fulfillTransaction() {
            let payload = {
                route: this.transactionUrl,
                gateway: this.gateway.id,
                billing: {
                    billingSelf: this.billingSelf,
                    name: this.details.billingName,
                    phone: this.details.billingPhone,
                    email: this.details.billingEmail,
                    zip: this.details.billingZip,
                    city: this.details.billingCity,
                    address: this.details.billingAddress,
                    isTaxNumber: this.isTaxNumber,
                    taxNumber: this.details.taxNumber
                },
                // warehouse: this.details.warehouse,
                shippingName: this.details.shippingName,
                shippingZip: this.details.shippingZip,
                shippingCity: this.details.shippingCity,
                shippingAddress: this.details.shippingAddress,
            }

            this.$store.dispatch('ORDER_FULFILL_TRANSACTION', payload).then((resp) => {
                if (resp.url) {
                    window.location.href = resp.url
                }
            }).catch((response) => {
                if (response.errors) {
                    this.$store.commit('setValidation', response.errors)
                } else {
                    this.$store.commit('setNotification', [i18n.t('order.page.details.notification.finish_order.failed')])
                }
            })
        },

        setBillingType() {
            this.isTaxNumber = null
            this.details.taxNumber = null
            this.billingSelf
                ? this.setBilling()
                : this.emptyBillingInputs()
        },

        setBilling() {
            if (this.profile && this.profile.dealer) {
                this.details.billingName = this.profile.dealer.name
                this.details.billingZip = this.profile.dealer.addressZip
                this.details.billingCity = this.profile.dealer.addressCity
                this.details.billingAddress = this.profile.dealer.address
                this.details.billingEmail = this.profile.dealer.email
                this.details.billingPhone = this.profile.dealer.phone
            }
        },

        inputZip() {
            this.details.shippingCity = ''
            this.cityList = []
            this.checkZip()
        },

        inputBillingZip() {
            this.details.billingCity = ''
            this.cityList = []
            this.checkBillingZip()
        },

        checkZip() {
            this.$refs.addressZip.removeAttribute('tabindex')

            let zipLength = String(this.details.shippingZip).length
            if (zipLength > 4) {
                this.details.shippingZip = Number((String(this.details.shippingZip)).substring(0, 4))
            }

            if (this.details.shippingZip !== null && String(this.details.shippingZip).length === 4) {
                this.setCity()
            } else {
                this.cityList = []
            }
        },

        checkBillingZip() {
            this.$refs.billingAddressZip.removeAttribute('tabindex')

            let zipLength = String(this.details.billingZip).length
            if (zipLength > 4) {
                this.details.billingZip = Number((String(this.details.billingZip)).substring(0, 4))
            }

            if (this.details.billingZip !== null && String(this.details.billingZip).length === 4) {
                this.setBillingCity()
            } else {
                this.billingCityList = []
            }
        },

        inputCity() {
            this.details.shippingZip = ''
            this.zipList = []
            this.checkCity()
        },

        inputBillingCity() {
            this.details.billingZip = ''
            this.billingZipList = []
            this.checkBillingCity()
        },

        checkCity() {
            this.$refs.addressCity.removeAttribute('tabindex')

            if (this.details.shippingCity !== null && this.details.shippingCity.length > 2) {
                this.setZip()
            } else {
                this.zipList = []
            }
        },

        checkBillingCity() {
            this.$refs.billingAddressCity.removeAttribute('tabindex')

            if (this.details.billingCity !== null && this.details.billingCity.length > 2) {
                this.setBillingZip()
            } else {
                this.billingZipList = []
            }
        },

        blurCity() {
            this.citiesList.forEach(el => {
                if (el.name.toLowerCase() === this.details.shippingCity.toLowerCase() && el.name !== this.details.shippingCity) {
                    this.details.shippingCity = el.name
                }
            })
            this.emptyZipList()
        },

        blurBillingCity() {
            this.billingCityList.forEach(el => {
                if (el.name.toLowerCase() === this.details.billingCity.toLowerCase() && el.name !== this.details.billingCity) {
                    this.details.billingCity = el.name
                }
            })
            this.emptyBillingZipList()
        },

        setCity() {
            this.zipCodesList.forEach(el => {
                const sameZip = Number(el.zip) === Number(this.details.shippingZip)
                if (sameZip && el.cities.length === 1) {
                    this.$refs.addressCity.setAttribute('tabindex', '-1')
                    this.details.shippingCity = el.cities[0]
                } else if (sameZip && el.cities.length > 1) {
                    this.cityList = el.cities
                }
            })
        },

        setBillingCity() {
            this.zipCodesList.forEach(el => {
                const sameZip = Number(el.zip) === Number(this.details.billingZip)
                if (sameZip && el.cities.length === 1) {
                    this.$refs.billingAddressCity.setAttribute('tabindex', '-1')
                    this.details.billingCity = el.cities[0]
                } else if (sameZip && el.cities.length > 1) {
                    this.billingCityList = el.cities
                }
            })
        },

        setZip() {
            this.citiesList.forEach(el => {
                if (el.name.toLowerCase() === this.details.shippingCity.toLowerCase()) {
                    if (el.zips.length === 1) {
                        this.$refs.addressZip.setAttribute('tabindex', '-1')
                        this.details.shippingZip = el.zips[0]
                    } else {
                        this.zipList = el.zips
                    }
                }
            })
        },

        setBillingZip() {
            this.billingCityList.forEach(el => {
                if (el.name.toLowerCase() === this.details.billingCity.toLowerCase()) {
                    if (el.zips.length === 1) {
                        this.$refs.billingAddressZip.setAttribute('tabindex', '-1')
                        this.details.billingZip = el.zips[0]
                    } else {
                        this.billingZipList = el.zips
                    }
                }
            })
        },

        writeCityName(name) {
            this.$refs.addressCity.setAttribute('tabindex', '-1')
            this.details.shippingCity = name
            this.emptyZipList()
        },

        writeBillingCityName(name) {
            this.$refs.billingAddressCity.setAttribute('tabindex', '-1')
            this.details.billingCity = name
            this.emptyBillingZipList()
        },

        writeZip(zip) {
            this.$refs.addressZip.setAttribute('tabindex', '-1')
            this.details.shippingZip = zip
            this.emptyCityList()
        },

        writeBillingZip(zip) {
            this.$refs.billingAddressZip.setAttribute('tabindex', '-1')
            this.details.billingZip = zip
            this.emptyBillingCityList()
        },

        emptyCityList() {
            let that = this
            setTimeout(function () {
                if (that.cityList.length > 0) {
                    that.cityList = []
                }
            }, 250)
        },

        emptyBillingCityList() {
            let that = this
            setTimeout(function () {
                if (that.billingCityList.length > 0) {
                    that.billingCityList = []
                }
            }, 250)
        },

        emptyZipList() {
            let that = this
            setTimeout(function () {
                if (that.zipList.length > 0) {
                    that.zipList = []
                }
            }, 250)
        },

        emptyBillingZipList() {
            let that = this
            setTimeout(function () {
                if (that.billingZipList.length > 0) {
                    that.billingZipList = []
                }
            }, 250)
        },

        emptyBillingInputs() {
            this.details.billingName = ''
            this.details.billingZip = ''
            this.details.billingCity = ''
            this.details.billingAddress = ''
            this.details.billingEmail = ''
            this.details.billingPhone = ''
        },

        emptyShippingInputs() {
            this.details.shippingName = ''
            this.details.shippingZip = ''
            this.details.shippingCity = ''
            this.details.shippingAddress = ''
        },

        removeValidation(keys) {
            if (this.validation || Object.keys(this.validation).length > 0) {
                if (typeof keys === 'string') {
                    keys = [keys]
                }

                let validation = {...this.validation}
                let changed = false

                keys.forEach(key => {
                    if (validation[key]) {
                        delete validation[key]
                        changed = true
                    }
                })

                if (changed) {
                    this.disableScroll = true
                    this.$store.commit('setValidation', validation)
                }
            }
        },

        openModal(modal) {
            this.openedModal = modal
        },
        closeModal() {
            this.openedModal = ''
        },

        closePage() {
            this.$router.push({name: 'OrderStatus', params: {orderId: this.$route.params.orderId}})
        }
    },

    computed: {
        ...mapGetters(['orderStatus', 'orderDetails', 'profile', 'userHasObjects', 'userAuthenticated', 'zipCodesList', 'citiesList', 'validation'])
    },

    components: {
        ModalTerms,
        CustomSelect,
        JobNavigation, Notification
    }
}
</script>
